import { useSessionStorage } from "@uidotdev/usehooks";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import ReturnChargeIcon from "../../Icons/ReturnCharge";
import { IFilterReturn } from "../../types/interface";
import { hasValues } from "../../utils/hasValues";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import Modal from "../Reusable/Modal";
import Spinner from "../Reusable/Spinner";
import ReturnChargeSetting from "./ReturnCharge";
import ReturnOrderFilter from "./ReturnOrderFilter";

const ReturnOrderList = () => {
  const navigate = useNavigate();
  const [localState, handleSetState] = useSessionStorage<IFilterReturn>(
    "return-rtv-filter",
    {
      created__range: null,
      merchant: null,
      driver: null,
    }
  );
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));
  const [openRTvSettingPopup, setOpenRTVSettingPopup] = useState(false);
  const { setValue, getValues, watch, reset, control } = useForm<IFilterReturn>(
    {
      defaultValues: async () => ({
        created__range: localState?.created__range ?? null,
        merchant: localState?.merchant ?? null,
        driver: localState?.driver ?? null,
      }),
    }
  );

  const handleFilterReset = () => {
    reset({
      created__range: null,
      merchant: null,
      driver: null,
    });
  };
  const defaultColumns: any = [
    {
      header: "RTV/Return ID",
      accessorKey: "tracking_number",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Updated",
      accessorKey: "modified",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Vendor",
      accessorKey: "merchant.user.full_name",
      cell: NACell,
    },
    {
      header: "Driver",
      accessorKey: "driver.user.full_name",
      cell: NACell,
    },

    {
      header: "Total Items",
      accessorKey: "items.total",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Received Items",
      accessorKey: "items.received",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
    {
      header: "Missing Items",
      accessorKey: "items.missing",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
  ];
  const { data: RtvChargeSetting, isLoading } = useGetHook({
    queryKey: ["rtv-charge-setting"],
    url: `${APIS.RTV_CHARGE}`,
    params: {},
  });
  const handleEditNavigate = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };

  const filterParams = watch();

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]); //eslint-disable-line

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <ReturnOrderFilter
          isFilterVisible={isFilterVisible}
          setValue={setValue}
          getValues={getValues}
          handleFilterReset={handleFilterReset}
          control={control}
        />
      </Card>

      <DataTable
        url={`${APIS.RTV_ORDER}`}
        queryKey={"rtv-order"}
        handleEditNavigate={handleEditNavigate}
        columns={defaultColumns}
        tableName={"rtv-return"}
        orderSearch={true}
        addNewPagePath={"/create"}
        params={params()}
        rtvCharge={"/return-charge"}
        actionMenu={
          <>
            <div className={tw`w-full flex  justify-end items-center`}>
              <button
                onClick={() => setOpenRTVSettingPopup(!openRTvSettingPopup)}
                className={tw`p-2 flex gap-x-2 bg-primary-light  rounded text-primary`}
              >
                <ReturnChargeIcon color={"var(--primary)"} />
                RTV Charge
              </button>
            </div>
          </>
        }
      />
      <Modal
        title={"RTV Charge Setting"}
        isOpen={openRTvSettingPopup}
        setIsOpen={setOpenRTVSettingPopup}
      >
        {isLoading ? (
          <Spinner />
        ) : (
          <ReturnChargeSetting
            openRTvSettingPopup={openRTvSettingPopup}
            setOpenRTVSettingPopup={setOpenRTVSettingPopup}
            RtvChargeSetting={RtvChargeSetting}
          />
        )}
      </Modal>
    </>
  );
};

export default ReturnOrderList;
